import { BASE_URL } from "../../util/Constants";
import HTTP from "../../util/Http";

const createValoracion = async (valoracion, idactividad, alTerminar) => {
  const url = BASE_URL + "valoracion/" + idactividad;
  // CON AXIOS
  await HTTP.post(url, valoracion).then((response) => {
    console.log(response.data);
    alTerminar();
  });
};

const updateValoracion = async (valoracion, idactividad, alTerminar) => {
  const url = BASE_URL + "valoracion/" + idactividad;
  // CON AXIOS
  await HTTP.put(url, valoracion).then((response) => {
    console.log(response.data);
    alTerminar();
  });
};

const deleteValoracion = async (idvaloracion, alTerminar) => {
  const url = BASE_URL + "valoracion/" + idvaloracion;
  // CON AXIOS
  await HTTP.delete(url).then((response) => {
    console.log(response.data);
    alTerminar();
  });
};

export { createValoracion, updateValoracion, deleteValoracion };
